<mat-card style="text-align: center">

  <h3>Account security</h3>

  <ng-container *ngIf="alreadyActive">
    <div>
      <mat-icon style="color: forestgreen; font-size: 1em; margin: 0; padding: 0; height: auto; width: auto;">security</mat-icon> You have already activated Two-Factor Authentication.
    </div>

    <br /><br />
    <button mat-raised-button color="primary" (click)="returnBack()" type="button">Go back</button>

  </ng-container>


  <ng-container *ngIf="!alreadyActive">

    <div>
      <mat-icon style="color: orange; font-size: 1em; margin: 0; padding: 0; height: auto; width: auto;">security</mat-icon>
      You need to secure your account by activating two-factor authentication
    </div>


      <br />
      <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="goToActivateTotp()"><mat-icon style="font-size: 1em; margin: 0; padding: 0; height: auto; width: auto;">security</mat-icon> Start set-up</button>

    <br />
    <br />

  </ng-container>

</mat-card>
